module.exports = __webpack_public_path__ + "img/btn-ticket-active.f7c94fd1.svg";